<template>
  <div id="completed-health-check-content">
  <div class="row">
    <!-- Substitution, Direction and MOO -->
    <div class="col-12">
      <b-card header="Substitution, Direction and MOO" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Does your company have ultimate right of control over the tasks to be done? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_right_of_control')">
                <div class="text">
                  <span v-if="health_check.company_right_of_control === 'Yes'">Fail</span>
                  <span v-if="health_check.company_right_of_control === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does your company have ultimate right of control over the tasks to be done?</p>
              <p v-if="health_check.company_right_of_control === 'Yes'" class="red_color mb-1">
                Yes - we will ensure that tasks are carried out in the correct manner inline with the company standards.
              </p>
              <p v-else-if="health_check.company_right_of_control === 'No'" class="green_color mb-1">
                No - the Contractor has full control over every task being completed.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_right_of_control }}</p>
            </div>
          </div>
          <!-- Do the contractors have the right to send a substitute? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_right_to_substitution')">
                <div class="text">
                  <span v-if="health_check.contractor_right_to_substitution === 'Yes'">Pass</span>
                  <span v-if="health_check.contractor_right_to_substitution === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the contractors have the right to send a substitute?</p>
              <p v-if="health_check.contractor_right_to_substitution === 'Yes'" class="green_color mb-1">
                Yes – have the right to send a substitute.
              </p>
              <p v-else-if="health_check.contractor_right_to_substitution === 'No'" class="red_color mb-1">
                No – no right to send someone in place.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_right_to_substitution }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-2" v-if="health_check.contractor_right_to_substitution === 'Yes'">
          <!-- Who is responsible for paying a substitute? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('pay_substitute_responsibility')">
                <div class="text">
                  <span v-if="health_check.pay_substitute_responsibility === 'Company'">Warning</span>
                  <span v-if="health_check.pay_substitute_responsibility === 'Contractor'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Who is responsible for paying a substitute?</p>
              <p v-if="health_check.pay_substitute_responsibility === 'Company'" class="orange_color mb-1">
                We pay the replacement contractor direct.
              </p>
              <p v-else-if="health_check.pay_substitute_responsibility === 'Contractor'" class="green_color mb-1">
                We would expect the contractor to sort the payments.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_pay_substitute_responsibility }}</p>
            </div>
          </div>
          <!-- Do you the client have the right to reject a substitute? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_right_to_reject_substitute')">
                <div class="text">
                  <span v-if="health_check.company_right_to_reject_substitute === 'No'">Fail</span>
                  <span v-if="health_check.company_right_to_reject_substitute === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do you the client have the right to reject a substitute?</p>
              <p v-if="health_check.company_right_to_reject_substitute === 'No'" class="red_color mb-1">
                No - we would accept them.
              </p>
              <p v-else-if="health_check.company_right_to_reject_substitute === 'Yes'" class="green_color mb-1">
                Yes - we can reject them.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_right_to_reject_substitute }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <!-- Do the contractors have set hours? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_set_hours')">
                <div class="text">
                  <span v-if="health_check.contractor_set_hours === 'Yes'">Warning</span>
                  <span v-if="health_check.contractor_set_hours === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the contractors have set hours?</p>
              <p v-if="health_check.contractor_set_hours === 'Yes'" class="orange_color mb-1">
                Yes - set hours in line with the site opening times.
              </p>
              <p v-else-if="health_check.contractor_set_hours === 'No'" class="red_color mb-1">
                No - contractors can chose working hours.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_set_hours }}</p>
            </div>
          </div>
          <!-- Have any contractors sent alternative labour when they are unable to work? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('historic_contractor_sent_alternative_labour')">
                <div class="text">
                  <span v-if="health_check.historic_contractor_sent_alternative_labour === 'Yes_No_Sub'">Warning</span>
                  <span v-if="health_check.historic_contractor_sent_alternative_labour === 'Yes'">Pass</span>
                  <span v-if="health_check.historic_contractor_sent_alternative_labour === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Have any contractors sent alternative labour when they are unable to work?</p>
              <p v-if="health_check.historic_contractor_sent_alternative_labour === 'Yes'" class="orange_color mb-1">
                Yes – they have the right but never had a substitution.
              </p>
              <p v-else-if="health_check.historic_contractor_sent_alternative_labour === 'Yes'" class="green_color mb-1">
                Yes - previously had contractors sending others to work in their place.
              </p>
              <p v-else-if="health_check.historic_contractor_sent_alternative_labour === 'No'" class="red_color mb-1">
                No - this doesn't happen.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_historic_contractor_sent_alternative_labour }}</p>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <!-- Could the contractors engage additional support (contractors) at their own expense? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractors_engage_additional_support_own_cost')">
                <div class="text">
                  <span v-if="health_check.contractors_engage_additional_support_own_cost === 'No'">Fail</span>
                  <span v-if="health_check.contractors_engage_additional_support_own_cost === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Could the contractors engage additional support (contractors) at their own expense?</p>
              <p v-if="health_check.contractors_engage_additional_support_own_cost === 'No'" class="red_color mb-1">
                No - the company would bring in any additional labour.
              </p>
              <p v-else-if="health_check.contractors_engage_additional_support_own_cost === 'Yes'" class="green_color mb-1">
                Yes – the contractor would be responsible to find any additional support.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractors_engage_additional_support_own_cost }}</p>
            </div>
          </div>
          <!-- Can the contractor decline work offered from you? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_decline_work')">
                <div class="text">
                  <span v-if="health_check.contractor_decline_work === 'Yes'">Pass</span>
                  <span v-if="health_check.contractor_decline_work === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Can the contractor decline work offered from you?</p>
              <p v-if="health_check.contractor_decline_work === 'Yes'" class="green_color mb-1">
                Yes - and we do not have to provide work beyond the initial contract.
              </p>
              <p v-else-if="health_check.contractor_decline_work === 'No'" class="red_color mb-1">
                No - we dictate what sites they are working on and when.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_decline_work }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <!-- Right to Work -->
    <div class="col-12">
      <b-card header="Right to Work" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row">
          <!-- Does your company carry out right to work checks for all contractors you engage with? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_carry_out_right_to_work_checks')">
                <div class="text">
                  <span v-if="health_check.company_carry_out_right_to_work_checks === 'No'">Fail</span>
                  <span v-else-if="health_check.company_carry_out_right_to_work_checks === 'No_Current_Provider'">Warning</span>
                  <span v-else-if="health_check.company_carry_out_right_to_work_checks === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does your company carry out right to work checks for all contractors you engage with?</p>
              <p v-if="health_check.company_carry_out_right_to_work_checks === 'No'" class="red_color mb-1">
                No.
              </p>
              <p v-else-if="health_check.company_carry_out_right_to_work_checks === 'No_Current_Provider'" class="orange_color mb-1">
                No - Our current recruitment agency/outsourced provider deal with this.
              </p>
              <p v-else-if="health_check.company_carry_out_right_to_work_checks === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_carry_out_right_to_work_checks }}</p>
            </div>
          </div>
          <!-- How do you ensure non UK workers are eligible to work in the UK? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('how_check_non_uk_right_to_work')">
                <div class="text">
                  <span v-if="health_check.how_check_non_uk_right_to_work === 'No_Checks'">Fail</span>
                  <span v-else-if="health_check.how_check_non_uk_right_to_work === 'ID'">Fail</span>
                  <span v-else-if="health_check.how_check_non_uk_right_to_work === 'R2W_Code'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">How do you ensure non UK workers are eligible to work in the UK?</p>
              <p v-if="health_check.how_check_non_uk_right_to_work === 'No_Checks'" class="red_color mb-1">
                No checks performed.
              </p>
              <p v-else-if="health_check.how_check_non_uk_right_to_work === 'ID'" class="red_color mb-1">
                We check their ID.
              </p>
              <p v-else-if="health_check.how_check_non_uk_right_to_work === 'R2W_Code'" class="green_color mb-1">
                We ensure that the workers provide settlement code or biometric code along with their ID ahead of starting.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_how_check_non_uk_right_to_work }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
  <div class="html2pdf__page-break"></div>
  &nbsp;
  <div class="row">
    <!-- Financial Risk -->
    <div class="col-12">
      <b-card header="Financial Risk" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Do the contractors carry their own insurance? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractors_have_own_insurance')">
                <div class="text">
                  <span v-if="health_check.contractors_have_own_insurance === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractors_have_own_insurance === 'No_Company_Insurance'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the contractors carry their own insurance?</p>
              <p v-if="health_check.contractors_have_own_insurance === 'Yes'" class="green_color mb-1">
                Yes - it is the contractors liability to insure themselves.
              </p>
              <p v-else-if="health_check.contractors_have_own_insurance === 'No_Company_Insurance'" class="red_color mb-1">
                No - the contractors fall under our insurance.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractors_have_own_insurance }}</p>
            </div>
          </div>
          <!-- Do the contractors invoice for the work? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractors_invoice_for_work')">
                <div class="text">
                  <span v-if="health_check.contractors_invoice_for_work === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractors_invoice_for_work === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the contractors invoice for the work?</p>
              <p v-if="health_check.contractors_invoice_for_work === 'Yes'" class="green_color mb-1">
                Yes - they invoice for works carried out at the end of each week.
              </p>
              <p v-else-if="health_check.contractors_invoice_for_work === 'No'" class="red_color mb-1">
                No - we calculate the hours worked on the timesheet and submit the work.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractors_invoice_for_work }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Is there a risk of financial loss to the contractors? (not just unpaid wages) -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractors_financial_risk')">
                <div class="text">
                  <span v-if="health_check.contractors_financial_risk === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractors_financial_risk === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Is there a risk of financial loss to the contractors? (not just unpaid wages)</p>
              <p v-if="health_check.contractors_financial_risk === 'Yes'" class="green_color mb-1">
                Yes - they must complete any errors within their own time and unpaid.
              </p>
              <p v-else-if="health_check.contractors_financial_risk === 'No'" class="red_color mb-1">
                No - any errors get rectified as they go.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractors_financial_risk }}</p>
            </div>
          </div>
          <!-- How will the contractor be paid for the work, Daily, hourly or Price? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_pay_type')">
                <div class="text">
                  <span v-if="health_check.contractor_pay_type === 'Price'">Pass</span>
                  <span v-else-if="health_check.contractor_pay_type === 'Daily'">Warning</span>
                  <span v-else-if="health_check.contractor_pay_type === 'Hourly'">Warning</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">How will the contractor be paid for the work, Daily, hourly or Price</p>
              <p v-if="health_check.contractor_pay_type === 'Price'" class="green_color mb-1">
                Price Work.
              </p>
              <p v-else-if="health_check.contractor_pay_type === 'Daily'" class="orange_color mb-1">
                Daily Rate.
              </p>
              <p v-else-if="health_check.contractor_pay_type === 'Hourly'" class="orange_color mb-1">
                Hourly Rate.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_pay_type }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <!-- Contracts -->
    <div class="col-12">
      <b-card header="Contracts" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Is a contract provided for every job undertaken by a Contractor? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_contract_for_every_job')">
                <div class="text">
                  <span v-if="health_check.contractor_contract_for_every_job === 'No_Contract'">Fail</span>
                  <span v-else-if="health_check.contractor_contract_for_every_job === 'No_At_Start'">Fail</span>
                  <span v-else-if="health_check.contractor_contract_for_every_job === 'No_Yearly'">Warning</span>
                  <span v-else-if="health_check.contractor_contract_for_every_job === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Is a contract provided for every job undertaken by a Contractor?</p>
              <p v-if="health_check.contractor_contract_for_every_job === 'No_Contract'" class="red_color mb-1">
                No - a contract is not provided.
              </p>
              <p v-else-if="health_check.contractor_contract_for_every_job === 'No_At_Start'" class="orange_color mb-1">
                No - an initial contract is provided when they start.
              </p>
              <p v-else-if="health_check.contractor_contract_for_every_job === 'No_Yearly'" class="orange_color mb-1">
                No - a contract is provided and renewed each year.
              </p>
              <p v-else-if="health_check.contractor_contract_for_every_job === 'Yes'" class="green_color mb-1">
                Yes - a contract is provided for every job given.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_contract_for_every_job }}</p>
            </div>
          </div>
          <!-- Does a Contractor who works on multiple sites at the same time receive a contract relevant to each location? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_contract_for_every_site')">
                <div class="text">
                  <span v-if="health_check.contractor_contract_for_every_site === 'No'">Fail</span>
                  <span v-else-if="health_check.contractor_contract_for_every_site === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does a Contractor who works on multiple sites at the same time receive a contract relevant to each location?</p>
              <p v-if="health_check.contractor_contract_for_every_site === 'No'" class="red_color mb-1">
                No - they may have to be on several sites each day it isn’t realistic.
              </p>
              <p v-else-if="health_check.contractor_contract_for_every_site === 'Yes'" class="green_color mb-1">
                Yes - they will always be finished up on their initial site and provided with a new contract.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_contract_for_every_site }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <!-- Do the current contracts provided have fixed end dates? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_contract_fixed_end_date')">
                <div class="text">
                  <span v-if="health_check.contractor_contract_fixed_end_date === 'No'">Fail</span>
                  <span v-else-if="health_check.contractor_contract_fixed_end_date === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the current contracts provided have fixed end dates?</p>
              <p v-if="health_check.contractor_contract_fixed_end_date === 'No'" class="red_color mb-1">
                No.
              </p>
              <p v-else-if="health_check.contractor_contract_fixed_end_date === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_contract_fixed_end_date }}</p>
            </div>
          </div>
          <!-- Does your company know who will be performing work? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_know_who_will_complete_work')">
                <div class="text">
                  <span v-if="health_check.company_know_who_will_complete_work === 'Yes'">Warning</span>
                  <span v-else-if="health_check.company_know_who_will_complete_work === 'No'">Pass</span>
                  <span v-else-if="health_check.company_know_who_will_complete_work === 'Sometimes'">Warning</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does your company know who will be performing work?</p>
              <p v-if="health_check.company_know_who_will_complete_work === 'Yes'" class="orange_color mb-1">
                Yes - we will typically engage the individual for the work.
              </p>
              <p v-else-if="health_check.company_know_who_will_complete_work === 'No'" class="green_color mb-1">
                No - we use a recruitment agency, and the individual turns up on site on the day.
              </p>
              <p v-else-if="health_check.company_know_who_will_complete_work === 'Sometimes'" class="orange_color mb-1">
                Sometimes - mixture of the above.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_know_who_will_complete_work }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <!-- Is notice given to terminate service or to lay anyone off? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_notice_given')">
                <div class="text">
                  <span v-if="health_check.contractor_notice_given === 'No_Notice'">Pass</span>
                  <span v-else-if="health_check.contractor_notice_given === 'No_Agency'">Pass</span>
                  <span v-else-if="health_check.contractor_notice_given === 'Yes'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does your company know who will be performing work?</p>
              <p v-if="health_check.contractor_notice_given === 'No_Notice'" class="green_color mb-1">
                No – no notice needs to be given.
              </p>
              <p v-else-if="health_check.contractor_notice_given === 'No_Agency'" class="green_color mb-1">
                No – we advise the agency who does this for us.
              </p>
              <p v-else-if="health_check.contractor_notice_given === 'Yes'" class="red_color mb-1">
                Yes.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_notice_given }}</p>
            </div>
          </div>
          <!-- Do your contracts stop the contractor from doing similar work for other companies? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_work_for_other_companies')">
                <div class="text">
                  <span v-if="health_check.contractor_work_for_other_companies === 'Yes'">Fail</span>
                  <span v-else-if="health_check.contractor_work_for_other_companies === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do your contracts stop the contractor from doing similar work for other companies?</p>
              <p v-if="health_check.contractor_work_for_other_companies === 'Yes'" class="red_color mb-1">
                Yes - typically the contractor only works for us.
              </p>
              <p v-else-if="health_check.contractor_work_for_other_companies === 'No'" class="green_color mb-1">
                No - they are free to complete work for any other client.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_work_for_other_companies }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- How would the contractor introduce themselves to your consumers or suppliers? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_introduce_to_consumer_supplier')">
                <div class="text">
                  <span v-if="health_check.contractor_introduce_to_consumer_supplier === 'Work_For_Company'">Fail</span>
                  <span v-else-if="health_check.contractor_introduce_to_consumer_supplier === 'Worker_Engaged_By_Third_Party'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">How would the contractor introduce themselves to your consumers or suppliers?</p>
              <p v-if="health_check.contractor_introduce_to_consumer_supplier === 'Work_For_Company'" class="red_color mb-1">
                The contractor would say they work for the company.
              </p>
              <p v-else-if="health_check.contractor_introduce_to_consumer_supplier === 'Worker_Engaged_By_Third_Party'" class="green_color mb-1">
                The contractor would say they are engaged via a third party (e.g. Recruitment/Payroll Company).
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_introduce_to_consumer_supplier }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
  <div class="html2pdf__page-break"></div>
  &nbsp;
  <div class="row">
    <!-- Benefits -->
    <div class="col-12">
      <b-card header="Benefits" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Do you arrange training courses? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_arrange_training')">
                <div class="text">
                  <span v-if="health_check.company_arrange_training === 'Yes'">Warning</span>
                  <span v-else-if="health_check.company_arrange_training === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do you arrange training courses?</p>
              <p v-if="health_check.company_arrange_training === 'Yes'" class="orange_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.company_arrange_training === 'No'" class="green_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_arrange_training }}</p>
            </div>
          </div>
          <!-- Does the company pay for training? -->
          <div class="col-xl-6" v-if="health_check.company_arrange_training === 'Yes'">
            <div class="result">
              <div class="outer" :class="check_health_check('company_pay_for_training')">
                <div class="text">
                  <span v-if="health_check.company_pay_for_training === 'No'">Pass</span>
                  <span v-else-if="health_check.company_pay_for_training === 'Yes'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does the company pay for training?</p>
              <p v-if="health_check.company_pay_for_training === 'No'" class="green_color mb-1">
                No – contractor pays for any training themselves.
              </p>
              <p v-else-if="health_check.company_pay_for_training === 'Yes'" class="red_color mb-1">
                Yes - pay for any training carried out.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_pay_for_training }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <!-- Do the contractors use holiday request forms? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_use_holiday_request_form')">
                <div class="text">
                  <span v-if="health_check.contractor_use_holiday_request_form === 'Yes'">Fail</span>
                  <span v-else-if="health_check.contractor_use_holiday_request_form === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do the contractors use holiday request forms?</p>
              <p v-if="health_check.contractor_use_holiday_request_form === 'Yes'" class="red_color mb-1">
                Yes - contractors apply for holiday leave.
              </p>
              <p v-else-if="health_check.contractor_use_holiday_request_form === 'No'" class="green_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_use_holiday_request_form }}</p>
            </div>
          </div>
          <!-- Do you provide the contractors with Vans? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_provide_vans')">
                <div class="text">
                  <span v-if="health_check.company_provide_vans === 'Yes'">Warning</span>
                  <span v-else-if="health_check.company_provide_vans === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do you provide the contractors with Vans?</p>
              <p v-if="health_check.company_provide_vans === 'Yes'" class="orange_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.company_provide_vans === 'No'" class="green_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_provide_vans }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-2" v-if="health_check.company_provide_vans === 'Yes'">
          <!-- Does the contractor pay for these vans? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_pay_for_company_vans')">
                <div class="text">
                  <span v-if="health_check.contractor_pay_for_company_vans === 'No'">Warning</span>
                  <span v-else-if="health_check.contractor_pay_for_company_vans === 'Yes'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does the contractor pay for these vans?</p>
              <p v-if="health_check.contractor_pay_for_company_vans === 'No'" class="orange_color mb-1">
                No - paid for by the client.
              </p>
              <p v-else-if="health_check.contractor_pay_for_company_vans === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_pay_for_company_vans }}</p>
            </div>
          </div>
          <!-- How are the vans used? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_vans_how_used')">
                <div class="text">
                  <span v-if="health_check.company_vans_how_used === 'Work'">Pass</span>
                  <span v-else-if="health_check.company_vans_how_used === 'Personal'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Does the contractor pay for these vans?</p>
              <p v-if="health_check.company_vans_how_used === 'Work'" class="green_color mb-1">
                Contractors drive from the yard and use them within working day.
              </p>
              <p v-else-if="health_check.company_vans_how_used === 'Personal'" class="red_color mb-1">
                Contractors take them home each evening.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_vans_how_used }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Will you provide the contractor with paid-for corporate benefits? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_provided_corporate_benefits')">
                <div class="text">
                  <span v-if="health_check.contractor_provided_corporate_benefits === 'No'">Pass</span>
                  <span v-else-if="health_check.contractor_provided_corporate_benefits === 'Yes'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Will you provide the contractor with paid-for corporate benefits?</p>
              <p v-if="health_check.contractor_provided_corporate_benefits === 'No'" class="green_color mb-1">
                No.
              </p>
              <p v-else-if="health_check.contractor_provided_corporate_benefits === 'Yes'" class="red_color mb-1">
                Yes - e.g. Vans, Paid Leave, Equipment, Tools, Materials, etc.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_provided_corporate_benefits }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
        <!-- Duties -->
    <div class="col-12">
      <b-card header="Duties" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Will any of the contractors be 'Office Holders'? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_office_holder')">
                <div class="text">
                  <span v-if="health_check.contractor_office_holder === 'No'">Pass</span>
                  <span v-else-if="health_check.contractor_office_holder === 'Some'">Warning</span>
                  <span v-else-if="health_check.contractor_office_holder === 'Yes'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Will you provide the contractor with paid-for corporate benefits?</p>
              <p v-if="health_check.contractor_office_holder === 'No'" class="green_color mb-1">
                No - all construction.
              </p>
              <p v-else-if="health_check.contractor_office_holder === 'Some'" class="orange_color mb-1">
                There will be some office holders.
              </p>
              <p v-else-if="health_check.contractor_office_holder === 'Yes'" class="red_color mb-1">
                Yes.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_office_holder }}</p>
            </div>
          </div>
          <!-- Do contractors provide their service through a limited company or as a sole trader? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_ltd_sole_trader')">
                <div class="text">
                  <span v-if="health_check.contractor_ltd_sole_trader === 'Limited_Company'">Pass</span>
                  <span v-else-if="health_check.contractor_ltd_sole_trader === 'Sole_Trader'">Pass</span>
                  <span v-else-if="health_check.contractor_ltd_sole_trader === 'Both'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Do contractors provide their service through a limited company or as a sole trader?</p>
              <p v-if="health_check.contractor_ltd_sole_trader === 'Limited_Company'" class="green_color mb-1">
                Limited Company.
              </p>
              <p v-else-if="health_check.contractor_ltd_sole_trader === 'Sole_Trader'" class="green_color mb-1">
                Sole Trader.
              </p>
              <p v-else-if="health_check.contractor_ltd_sole_trader === 'Both'" class="green_color mb-1">
                A mixture of the above.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_office_holder }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Is personal service required? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_personal_service_required')">
                <div class="text">
                  <span v-if="health_check.contractor_personal_service_required === 'Yes'">Fail</span>
                  <span v-else-if="health_check.contractor_personal_service_required === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-1 font-weight-bold">Is personal service required?</p>
              <p v-if="health_check.contractor_personal_service_required === 'Yes'" class="red_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.contractor_personal_service_required === 'No'" class="green_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_personal_service_required }}</p>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
  <div class="html2pdf__page-break"></div>
  &nbsp;
  <div class="row">
    <!-- Working Arrangement -->
    <div class="col-12">
      <b-card header="Working Arrangement" header-tag="h4" body-class="mb-3 pb-2">
        <div class="row mb-2">
          <!-- Do contractors have to buy equipment before the company pays them? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_buy_equipment')">
                <div class="text">
                  <span v-if="health_check.contractor_buy_equipment === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractor_buy_equipment === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-0 font-weight-bold">Do contractors have to buy equipment before the company pays them?</p>
              <p class="mb-1" style="font-size: 0.65rem; font-style: italic">This can include heavy machinery or high-cost specialist equipment.</p>
              <p v-if="health_check.contractor_buy_equipment === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.contractor_buy_equipment === 'No'" class="red_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_buy_equipment }}</p>
            </div>
          </div>
          <!-- Do contractors have to buy materials before the company pays them? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_buy_materials')">
                <div class="text">
                  <span v-if="health_check.contractor_buy_materials === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractor_buy_materials === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-0 font-weight-bold">Do contractors have to buy materials before the company pays them?</p>
              <p class="mb-1" style="font-size: 0.65rem; font-style: italic">This can include items that form a lasting part of the work, or are left behind when the worker
                leaves.</p>
              <p v-if="health_check.contractor_buy_materials === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.contractor_buy_materials === 'No'" class="red_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_buy_materials }}</p>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <!-- Will contractors have to fund any other costs before the company pays them?? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_fund_any_other_cost')">
                <div class="text">
                  <span v-if="health_check.contractor_fund_any_other_cost === 'Yes'">Pass</span>
                  <span v-else-if="health_check.contractor_fund_any_other_cost === 'No'">Fail</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-0 font-weight-bold">Will contractors have to fund any other costs before the company pays them?</p>
              <p class="mb-1" style="font-size: 0.65rem; font-style: italic">This can include non-commuting travel or accommodation, or external business premises for this
                work only.</p>
              <p v-if="health_check.contractor_fund_any_other_cost === 'Yes'" class="green_color mb-1">
                Yes.
              </p>
              <p v-else-if="health_check.contractor_fund_any_other_cost === 'No'" class="red_color mb-1">
                No.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_fund_any_other_cost }}</p>
            </div>
          </div>
          <!-- Do you provide PPE? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('company_provide_ppe')">
                <div class="text">
                  <span v-if="health_check.company_provide_ppe === 'Yes'">Fail</span>
                  <span v-else-if="health_check.company_provide_ppe === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-0 font-weight-bold">Do you provide PPE?</p>
              <p v-if="health_check.company_provide_ppe === 'Yes'" class="red_color mb-1">
                Yes - all contractors are provided with the relevant PPE.
              </p>
              <p v-else-if="health_check.company_provide_ppe === 'No'" class="green_color mb-1">
                No - contractors provide their own PPE.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_company_provide_ppe }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- Do the CIS contractors work alongside PAYE employees? -->
          <div class="col-xl-6">
            <div class="result">
              <div class="outer" :class="check_health_check('contractor_work_alongside_paye')">
                <div class="text">
                  <span v-if="health_check.contractor_work_alongside_paye === 'Yes'">Warning</span>
                  <span v-else-if="health_check.contractor_work_alongside_paye === 'No'">Pass</span>
                </div>
              </div>
            </div>
            <div class="info">
              <p class="mb-0 font-weight-bold">Do the CIS contractors work alongside PAYE employees?</p>
              <p v-if="health_check.contractor_work_alongside_paye === 'Yes'" class="orange_color mb-1">
                Yes - there is a mixture of both PAYE.
              </p>
              <p v-else-if="health_check.contractor_work_alongside_paye === 'No'" class="green_color mb-1">
                No - all self-employed within the company.
              </p>
              <p class="mb-1 font-weight-bold">Details</p>
              <p class="mb-1">{{ health_check.text_contractor_work_alongside_paye }}</p>
            </div>
          </div>
        </div>

          <div class="row signature-container">
              <div class="col-12 signature-wrapper">
            <div class="info">
              <p class="mb-0 font-weight-bold">Signature</p>
              <p v-if="health_check.signature_sign" class="orange_color mb-1">
                <img :src="health_check.signature_sign" id="signature_sign_result" class="border" />
              </p>
            </div>
          </div>
              <div class="col-12 signature-wrapper">
              <p class="mb-0 font-weight-bold">Date</p>
              <p v-if="health_check.signature_date" class="orange_color mb-1">
                <img :src="health_check.signature_date" id="signature_date_result" class="border" />
              </p>
          </div>
        </div>

      </b-card>
    </div>

  </div>
  </div>
</template>

<script>
export default {
  name: "completed_health_check",
  props: ['health_check', 'check_completed'],
  methods: {
    check_health_check(val) {
      let check_class = '';
      switch (val) {
        case 'company_right_of_control':
          if (this.health_check[val] === 'Yes') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'contractor_right_to_substitution':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'pay_substitute_responsibility':
          if (this.health_check[val] === 'Company') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'Contractor') {
            check_class = 'pass';
          }
          break;
        case 'company_right_to_reject_substitute':
          if (this.health_check[val] === 'No') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'contractor_set_hours':
          if (this.health_check[val] === 'Yes') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'historic_contractor_sent_alternative_labour':
          if (this.health_check[val] === 'Yes_No_Sub') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'contractors_engage_additional_support_own_cost':
          if (this.health_check[val] === 'No') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'contractor_decline_work':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break
          //
        case 'company_carry_out_right_to_work_checks':
          if (this.health_check[val] === 'No') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No_Current_Provider') {
            check_class = 'warning';
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'how_check_non_uk_right_to_work':
          if (this.health_check[val] === 'No_Checks') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'ID') {
            check_class = 'fail';
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
          //
        case 'contractors_have_own_insurance':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No_Company_Insurance') {
            check_class = 'fail';
          }
          break;
        case 'contractors_invoice_for_work':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'contractors_financial_risk':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'contractor_pay_type':
          if (this.health_check[val] === 'Price') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Daily') {
            check_class = 'amber';
          }
          else if (this.health_check[val] === 'Hourly') {
            check_class = 'amber';
          }
          break;
          //
        case 'contractor_contract_for_every_job':
          if (this.health_check[val] === 'No_Contract') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No_At_Start') {
            check_class = 'amber';
          }
          else if (this.health_check[val] === 'No_Yearly') {
            check_class = 'amber';
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'green';
          }
          break;
        case 'contractor_contract_for_every_site':
          if (this.health_check[val] === 'No') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'contractor_contract_fixed_end_date':
          if (this.health_check[val] === 'No') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'company_know_who_will_complete_work':
          if (this.health_check[val] === 'Yes') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          else if (this.health_check[val] === 'Sometimes') {
            check_class = 'amber';
          }
          break;
        case 'contractor_notice_given':
          if (this.health_check[val] === 'No_Notice') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No_Agency') {
            check_class = 'pass';
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'fail';
          }
          break;
        case 'contractor_work_for_other_companies':
          if (this.health_check[val] === 'Yes') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'contractor_introduce_to_consumer_supplier':
          if (this.health_check[val] === 'Work_For_Company') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'Worker_Engaged_By_Third_Party') {
            check_class = 'pass';
          }
          break;
          //
        case 'company_arrange_training':
          if (this.health_check[val] === 'Yes') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'company_pay_for_training':
          if (this.health_check[val] === 'No') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'fail';
          }
          break;
        case 'contractor_use_holiday_request_form':
          if (this.health_check[val] === 'Yes') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'company_provide_vans':
          if (this.health_check[val] === 'Yes') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'contractor_pay_for_company_vans':
          if (this.health_check[val] === 'No') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'pass';
          }
          break;
        case 'company_vans_how_used':
          if (this.health_check[val] === 'Work') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Personal') {
            check_class = 'fail';
          }
          break;
        case 'contractor_provided_corporate_benefits':
          if (this.health_check[val] === 'No') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'fail';
          }
          break;
          //
        case 'contractor_office_holder':
          if (this.health_check[val] === 'No') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Some') {
            check_class = 'amber';
          }
          else if (this.health_check[val] === 'Yes') {
            check_class = 'fail';
          }
          break;
        case 'contractor_ltd_sole_trader':
          if (this.health_check[val] === 'Limited_Company') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'Sole_Trader') {
            check_class = 'pass';
          }
          else if (this.health_check[val] === 'Both') {
            check_class = 'pass';
          }
          break;
        case 'contractor_personal_service_required':
          if (this.health_check[val] === 'Yes') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
          //
        case 'contractor_buy_equipment':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'contractor_buy_materials':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'contractor_fund_any_other_cost':
          if (this.health_check[val] === 'Yes') {
            check_class = 'pass'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'fail';
          }
          break;
        case 'company_provide_ppe':
          if (this.health_check[val] === 'Yes') {
            check_class = 'fail'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
        case 'contractor_work_alongside_paye':
          if (this.health_check[val] === 'Yes') {
            check_class = 'amber'
          }
          else if (this.health_check[val] === 'No') {
            check_class = 'pass';
          }
          break;
      }
      return check_class;
    }
  }
}
</script>

<style scoped lang="scss">
.result {
  width: 45px;
  display: inline-block;
  vertical-align: top;

  .outer {
    position: relative;
    display: block;
    border-radius: $border_radius_2;
    padding-top: 0;
    padding-bottom: 0;
    border: solid 2px #666666;
    border-left: 34px #666666 solid;
    margin-bottom: 0;
    height: 90px;
    text-align: center;
    width: 36px;

    &.fail {
      border-color: $red !important;
    }
    &.amber {
      border-color: $orange !important;
    }
    &.pass {
      border-color: $green !important;
    }

    .text {
      font-weight: bold;
      font-size: 1rem;
      color: #ffffff;
      text-transform: uppercase;
      position: absolute;
      right: -83px;
      transform-origin: top left;
      transform: rotate(90deg);
      width: 86px;
    }
  }
}
.info {
  width: calc(100% - 50px);
  display: inline-block;
  vertical-align: top;
}
</style>
